import get from 'lodash/get';
import * as giftGuide from '../../action_creators/gift_guide/gift_guide_details_action_creators';
import GiftGuideDetailsModel from '../../../models/gift_guide/gift_guide_detail_model';
import notFoundActionCreator from '../../action_creators/not_found_status_action_creator';
import log from '../../../services/logger_service';

export default function fetchGiftGuideDetail(params, store) {
  return function firstDispatch(dispatch) {
    return GiftGuideDetailsModel.fetch(params, store)
      .then(function handleGiftGuideDetailData(GiftGuideData) {
        dispatch(
          giftGuide.giftGuideDetailLoaded(
            GiftGuideData.data,
            store,
            params.year
          )
        );
      })
      .catch(function handleUserError(err) {
        if (err.message === 'Invalid Year') {
          log.warn('User tried a most creative people page with invalid year.');
          dispatch(notFoundActionCreator(404, 'NOT_FOUND_STATUS', store));
          return dispatch(giftGuide.giftGuideDetailLoadError(err, store));
        }

        const status = get(err, 'response.status');

        if (status === 404 || status === 401) {
          dispatch(notFoundActionCreator(404, 'NOT_FOUND_STATUS', store));
        }

        if (status === 500) {
          dispatch(notFoundActionCreator(500, 'ERROR_STATUS', store));
          log.error(
            err,
            `Error in giftGuideDetail actions, message: ${err.message}`
          );
        }
        return dispatch(giftGuide.giftGuideDetailLoadError(err, store));
      });
  };
}
